module.exports = "<div class=\"panel panel-default\" ng-class=\"{'panel-has-bc-toolbar': hasToolbar}\" ng-transclude></div>";